import { Flex, RemoteImage, useScreenSize } from '@banhala/ui-kit';
import { bridge, getImageSize, isNil, isNotNil, isWeb } from 'shared/src/utils';
import { useAiStudioBanner } from '../queries/useAiStudioBanner';
import { useEffect, useRef, useState } from 'react';

export const AiStudioBanner = () => {
  const { width } = useScreenSize();
  const isSetWidth = useRef(false);

  const { data: aiStudioBanner } = useAiStudioBanner();
  const [bannerSize, setBannerSize] = useState({ width, height: 48 });

  useEffect(() => {
    if (
      isNotNil(aiStudioBanner) &&
      isNotNil(aiStudioBanner.resource_image) &&
      !isSetWidth.current &&
      !isWeb
    ) {
      getImageSize(aiStudioBanner.resource_image.image_url)
        .then(size => {
          setBannerSize(prev => ({
            ...prev,
            height: size.height / 3,
          }));
          isSetWidth.current = true;
        })
        .catch(() => {});
    }
  }, [aiStudioBanner]);

  if (isNil(aiStudioBanner?.resource_image)) return null;

  return (
    <Flex
      onPress={() => {
        if (isNotNil(aiStudioBanner.logging)) {
          bridge.logAnalyticsEvent({
            name: 'CLICK_AI_STUDIO_BANNER',
            analytics: {
              SCREEN: 'GOODS_DETAIL',
              ...aiStudioBanner.logging.analytics,
            },
          });
        }
        if (isNotNil(aiStudioBanner.deeplink)) {
          bridge.openDeeplink(aiStudioBanner.deeplink);
        }
      }}
    >
      <RemoteImage
        uri={aiStudioBanner.resource_image.image_url}
        width={bannerSize.width}
        height={bannerSize.height}
      />
    </Flex>
  );
};
